export const GET_COUNTRIES = 'GET_COUNTRIES';

export const getCountriesAction = (payload) => ({ type: GET_COUNTRIES, payload });
